import { CHARACTER_ACTIONS } from "@/character/actions";
import {
  GRID_COLUMNS,
  GRID_ROWS,
  TEMPLATE_FRAME_HEIGHT,
  TEMPLATE_FRAME_WIDTH,
} from "@/character/grid";

export type ShadowFrameGrid = (string | null)[][];

export function emptyShadowFrameGrid(): ShadowFrameGrid {
  return Array.from({ length: GRID_ROWS }, () =>
    Array.from({ length: GRID_COLUMNS }, () => null),
  );
}

function loadImage(dataUrl: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("โหลดภาพไม่สำเร็จ"));
    img.src = dataUrl;
  });
}

function drawSpriteInCell(
  ctx: CanvasRenderingContext2D,
  img: HTMLImageElement,
  dx: number,
  dy: number,
  frameWidth: number,
  frameHeight: number,
): void {
  const scale = Math.min(frameWidth / img.naturalWidth, frameHeight / img.naturalHeight);
  const dw = img.naturalWidth * scale;
  const dh = img.naturalHeight * scale;
  const x = dx + (frameWidth - dw) / 2;
  const y = dy + frameHeight - dh;
  ctx.drawImage(img, x, y, dw, dh);
}

export function countFilledShadowFrameCells(grid: ShadowFrameGrid): number {
  let n = 0;
  for (let row = 0; row < GRID_ROWS; row += 1) {
    for (let col = 0; col < GRID_COLUMNS; col += 1) {
      if (grid[row]?.[col]) n += 1;
    }
  }
  return n;
}

export function missingShadowFrameCells(grid: ShadowFrameGrid): string[] {
  const missing: string[] = [];
  for (const action of CHARACTER_ACTIONS) {
    for (let col = 0; col < GRID_COLUMNS; col += 1) {
      if (!grid[action.row]?.[col]) {
        missing.push(`${action.templateLabel} · เฟรม ${col + 1}`);
      }
    }
  }
  return missing;
}

export async function composeShadowFrameGrid(
  grid: ShadowFrameGrid,
  frameWidth = TEMPLATE_FRAME_WIDTH,
  frameHeight = TEMPLATE_FRAME_HEIGHT,
): Promise<string> {
  const canvas = document.createElement("canvas");
  canvas.width = frameWidth * GRID_COLUMNS;
  canvas.height = frameHeight * GRID_ROWS;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("สร้างชีตไม่สำเร็จ");

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  for (let row = 0; row < GRID_ROWS; row += 1) {
    for (let col = 0; col < GRID_COLUMNS; col += 1) {
      const dx = col * frameWidth;
      const dy = row * frameHeight;
      const url = grid[row]?.[col];
      if (!url) {
        ctx.fillStyle = "rgba(18, 26, 36, 0.92)";
        ctx.fillRect(dx, dy, frameWidth, frameHeight);
        continue;
      }
      const img = await loadImage(url);
      drawSpriteInCell(ctx, img, dx, dy, frameWidth, frameHeight);
    }
  }

  return canvas.toDataURL("image/png");
}
